import {
  AiArtWorkStatus,
  pollAIArtWork,
  pollAIArtWorkVariables,
} from '~/graphqls/types'
import { useImperativeQuery } from '../useImperativeQuery'
import { POLL_AI_ARTWORK } from '~/graphqls/gqls'
import { message } from 'antd'

let timer: any = null

export const useValidateCreate = () => {
  const pollProductAction = useImperativeQuery<
    pollAIArtWork,
    pollAIArtWorkVariables
  >(POLL_AI_ARTWORK)

  const validateCreate = async (id: number) => {
    return new Promise(async resolve => {
      const poll = async (id: number) => {
        window.clearTimeout(timer)

        const res = await pollProductAction({ id })

        if (
          res.data.pictureGraph?.aiArtworkGeneratingInfo?.status ===
          AiArtWorkStatus.PREPARING
        ) {
          timer = window.setTimeout(() => poll(id), 1000)
        } else if (
          res.data.pictureGraph?.aiArtworkGeneratingInfo?.status ===
          AiArtWorkStatus.REJECTED
        ) {
          message.destroy()
          message.error(
            res.data.pictureGraph?.aiArtworkGeneratingInfo?.toastMessage ||
              '生成失败'
          )
          window.clearTimeout(timer)

          resolve(false)
        } else {
          window.clearTimeout(timer)
          resolve(true)
        }
      }

      poll(id)
    })
  }

  return {
    validateCreate,
  }
}
